import * as CONSTANTS from '../../constants';

export default {

    /**
     * Resets the timer, default value is 10.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.ALERT_COUNTDOWN_RESET] (state, payload) {
        state.message = payload;
        state.timer = 10;
    },

    /**
     * Decrements the timer.
     *
     * @param state
     */
    [CONSTANTS.ALERT_COUNTDOWN_DECREMENT] (state) {
        state.timer--;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/alert/mutations.js